export default "__VITE_ASSET__4PLaSSWO__"